import { Environment } from './environment.type';

export const environment: Environment = {
    stage: 'production',
    LPB_URL: 'https://api.bannerflow.com/landing-page-builder',
    AA_URL: 'https://api.bannerflow.com/account-access',
    LEGACY_URL: 'https://api.bannerflow.com/legacy',
    HOME_URL: 'https://home.bannerflow.com',
    LOGIN_URL: 'https://login.bannerflow.com',
    CLIENT_ID: 'kUYFYs0OZOh0BMSwXBZJOdOZ79lXNMgz',
    API_URLS: ['https://api.bannerflow.com'],
    version: '',
    newRelic: {
        enabled: true,
        accountId: '4122654',
        trustKey: '4122654',
        agentId: '538764755',
        licenseKey: 'NRJS-bd28b6acdc31b77b97c',
        applicationId: '538764755',
        origins: ['https://api.bannerflow.com']
    },
    featureFlags: {
        enabled: true,
        url: 'https://api.bannerflow.com/features/api/frontend',
        // Unleash frontend client keys are public and not sensitive (unlike API tokens)
        clientKey: '*:production.afcee879f498b5efc523eeb73cd42ce79fd37f1e23f7f50f7164e5f8'
    }
};
